import React from "react";
import styles from "./learningUnitButtons.module.css";
import { FaLightbulb } from "react-icons/fa6";
import { MdEdit } from "react-icons/md";
import { RiDeleteBin6Line } from "react-icons/ri";

const LearningUnitButtons = ({
  mayEditTool,
  isVoc,
  unitId,
  onCheckAnswer,
  onEditUnit,
  onDeleteUnit,
}) => {
  /* This component is responsible for the unit buttons: check answer, edit unit, and delete unit. */

  /* Check the user's answer */
  const handleCheckAnswerBtnClick = () => {
    onCheckAnswer(unitId);
  };

  /* Show the unit modal and allow the user to edit the unit */
  const handleEditUnitBtnClick = () => {
    onEditUnit(unitId);
  };

  /* Show the confirmation modal and allow the user to delete the unit */
  const handleDeleteUnitBtnClick = () => {
    onDeleteUnit(unitId);
  };

  return (
    <div className={styles.btnsContainer}>
      {!isVoc && (
        <button
          className={styles.checkAnswerIcon}
          onClick={handleCheckAnswerBtnClick}
        >
          <FaLightbulb />
        </button>
      )}
      {mayEditTool && (
        <button
          className={styles.editUnitIcon}
          onClick={handleEditUnitBtnClick}
        >
          <MdEdit />
        </button>
      )}
      {mayEditTool && (
        <button
          className={styles.deleteUnitIcon}
          onClick={handleDeleteUnitBtnClick}
        >
          <RiDeleteBin6Line />
        </button>
      )}
    </div>
  );
};

export default LearningUnitButtons;
